import { z } from 'zod';
import { platformModuleIdSchema, platformVersionedIdentifierSchema, } from '../modules/platform-module-manifest.contract.js';
export const platformPublicRequestGuardCapability = 'platform.public-request-guard.v1';
export const platformAccessGateNameSchema = z.enum([
    'packageInstalled',
    'deploymentEnabled',
    'dependenciesSatisfied',
    'tenantEntitled',
    'tenantEnabled',
    'userPermitted',
    'recordPolicyAllowed',
]);
export const platformAccessGateStateSchema = z.strictObject({
    packageInstalled: z.boolean(),
    deploymentEnabled: z.boolean(),
    dependenciesSatisfied: z.boolean(),
    tenantEntitled: z.boolean(),
    tenantEnabled: z.boolean(),
    userPermitted: z.boolean(),
    recordPolicyAllowed: z.boolean(),
});
export const platformCapabilityDecisionSchema = z.strictObject({
    allowed: z.boolean(),
    moduleId: platformModuleIdSchema,
    deniedBy: z.array(platformAccessGateNameSchema),
    gates: platformAccessGateStateSchema,
});
export const platformModuleActivationStateSchema = z.enum([
    'active',
    'deployment-disabled',
    'quarantined',
]);
export const platformModuleActivationReasonSchema = z.strictObject({
    code: z.enum([
        'platform.module.deployment-disabled.v1',
        'platform.module.initialization-failed.v1',
        'platform.module.dependency-unavailable.v1',
        'platform.module.capability-unavailable.v1',
    ]),
    subjectId: z.string().min(1).max(160),
    causalModuleIds: z.array(platformModuleIdSchema),
    failureCode: platformVersionedIdentifierSchema.nullable(),
});
export const platformEffectiveModuleSchema = z.strictObject({
    id: platformModuleIdSchema,
    version: z.string().regex(/^[0-9]+\.[0-9]+\.[0-9]+$/),
    required: z.boolean(),
    available: z.boolean(),
    deniedBy: z.array(platformAccessGateNameSchema),
    activation: z.strictObject({
        state: platformModuleActivationStateSchema,
        epoch: z.number().int().nonnegative(),
        reasons: z.array(platformModuleActivationReasonSchema),
    }),
    degradedModes: z.array(platformVersionedIdentifierSchema),
    provides: z.array(z.string()),
});
//# sourceMappingURL=platform-capability.contract.js.map